import { statsOnWidgetInteraction } from '../stats';


export function sliderSwiperWindow() {
	if (document.querySelectorAll('.swiper__container.__ver_wideo').length) {
		document.querySelectorAll('.swiper__container.__ver_wideo').forEach((gallery) => {

			const gallerySlider = gallery.querySelector('.gallery-slider');
			const btnPrev = gallery.querySelector('.swiper-button-prev');
			const btnNext = gallery.querySelector('.swiper-button-next');
			const slidesLength = gallerySlider.querySelectorAll('.swiper-slide').length;			
			let realIdx = 0;
			const swiper = new Swiper(gallerySlider, {
				spaceBetween: 5,
				navigation: {
					nextEl: btnNext,
					prevEl: btnPrev,
				},
				on: {
					realIndexChange() {
						const eventAction = 'ontouchstart' in document.documentElement ? 'tap' : 'click';
						const evType = this.swipeDirection ? 'swipe' : eventAction;
						const item = this.el.querySelector( `[aria-label="${this.realIndex}"]`);
						statsOnWidgetInteraction(gallery.querySelector('.swiper'), gallery, this.realIndex, evType);
						realIdx = this.realIndex;
					},
				},
			});

		});
	}	
}


/**
 * Ustawia na kontenerze slidera zmienna --map-photo-h z rzeczywista wysokoscia
 * zdjecia w slajdzie. CSS pozycjonuje na jej podstawie strzalki i paginacje pod
 * zdjeciem (__slider.scss, .__ver_map) – bez tego trzeba bylo wpisywac na sztywno
 * top: 450px / 80vw, co rozjezdzalo sie przy innych szerokosciach.
 * Zwraca funkcje przeliczajaca, do wywolania po init/resize swipera.
 */
function trackSlidePhotoHeight(gallery) {
	const getPhoto = () => gallery.querySelector('.swiper-slide-active .map__event_photo')
		|| gallery.querySelector('.map__event_photo');

	const update = () => {
		const photo = getPhoto();
		if (!photo) return;

		const height = photo.getBoundingClientRect().height;
		if (height) gallery.style.setProperty('--map-photo-h', Math.round(height) + 'px');
	};

	update();

	// zdjecie ma staly aspect-ratio, wiec jego wysokosc zmienia sie razem
	// z szerokoscia kontenera – ResizeObserver lapie to bez nasluchu na resize okna
	if (typeof ResizeObserver === 'function') {
		const photo = getPhoto();
		if (photo) new ResizeObserver(update).observe(photo);
	} else {
		window.addEventListener('resize', update);
	}

	return update;
}

export function sliderSwiperMap() {
	if (document.querySelectorAll('.swiper__container.__ver_map').length) {
		document.querySelectorAll('.swiper__container.__ver_map').forEach((gallery) => {

			const updatePhotoHeight = trackSlidePhotoHeight(gallery);
			const gallerySlider = gallery.querySelector('.gallery-slider');
			const btnPrev = gallery.querySelector('.swiper-button-prev');
			const btnNext = gallery.querySelector('.swiper-button-next');
			const pagination = gallery.querySelector('.swiper-pagination');
			const slidesLength = gallerySlider.querySelectorAll('.swiper-slide').length;
			let realIdx = 0;
			let lastIndex = 0;
			let swiper = new Swiper(gallerySlider, {
				loop: true,						
				slidesPerView: 1,
				centeredSlides: true,	
				spaceBetween: 10,	
				navigation: {
					nextEl: btnNext,
					prevEl: btnPrev,
				},
				pagination: {
					el: pagination,
					clickable: true,
				},

				on: {
					init: updatePhotoHeight,
					resize: updatePhotoHeight,
					realIndexChange() {
						const eventAction =
						'ontouchstart' in document.documentElement ? 'tap' : 'click';
						const evType = this.swipeDirection ? 'swipe' : eventAction;
						const item = this.el.querySelector(
						`[data-swiper-slide-index="${this.realIndex}"]`
						);
						statsOnWidgetInteraction(
						item,
						item.querySelector('img').getAttribute('src'),
						this.realIndex,
						evType
						);
						realIdx = this.realIndex;
					},
				},
		
			});
		})
	}
}




const WIDE_NAV_GAP = 21; // odstęp przycisków od aktywnego (powiększonego) zdjęcia
const WIDE_MOBILE_BREAKPOINT = 1080;
const WIDE_MOBILE_BUTTON_GAP = 12; // odstęp między przyciskami w mobilnym stosie

function positionWideNav(gallery, gallerySlider, btnPrev, btnNext) {
	const activeSlide = gallerySlider.querySelector('.swiper-slide-active');
	const img = activeSlide && activeSlide.querySelector('.swiper__img-wrapper img');
	if (!img) return;

	const galleryRect = gallery.getBoundingClientRect();
	const imgRect = img.getBoundingClientRect();

	if (window.innerWidth <= WIDE_MOBILE_BREAKPOINT) {
		// mobile: przyciski w stosie po prawej stronie zdjęcia (next nad prev),
		// wyśrodkowane na wysokości NASTĘPNEGO (peekującego) zdjęcia, nie aktywnego
		const imgRight = galleryRect.right - imgRect.right;
		const nextSlide = gallerySlider.querySelector('.swiper-slide-next');
		const nextImg = nextSlide && nextSlide.querySelector('.swiper__img-wrapper img');
		const nextImgRect = nextImg ? nextImg.getBoundingClientRect() : imgRect;
		const nextImgTop = nextImgRect.top - galleryRect.top;

		const stackHeight = btnNext.offsetHeight + WIDE_MOBILE_BUTTON_GAP + btnPrev.offsetHeight;
		const stackTop = nextImgTop + nextImgRect.height / 2 - stackHeight / 2;
		// przyciski wyśrodkowane na samej prawej krawędzi zdjęcia (pół na, pół za obrazkiem)
		const nextRight = imgRight - btnNext.offsetWidth / 2;
		const prevRight = imgRight - btnPrev.offsetWidth / 2;

		btnNext.style.left = 'auto';
		btnNext.style.right = `${nextRight}px`;
		btnNext.style.top = `${stackTop}px`;

		btnPrev.style.left = 'auto';
		btnPrev.style.right = `${prevRight}px`;
		btnPrev.style.top = `${stackTop + btnNext.offsetHeight + WIDE_MOBILE_BUTTON_GAP}px`;
		return;
	}

	const imgLeft = imgRect.left - galleryRect.left;
	const imgRight = galleryRect.right - imgRect.right;
	const imgBottom = imgRect.bottom - galleryRect.top;

	const prevTop = imgBottom - btnPrev.offsetHeight;
	const nextTop = imgBottom - btnNext.offsetHeight;

	btnPrev.style.left = `${imgLeft - WIDE_NAV_GAP - btnPrev.offsetWidth}px`;
	btnPrev.style.top = `${prevTop}px`;

	btnNext.style.left = 'auto';
	btnNext.style.right = `${imgRight - WIDE_NAV_GAP - btnNext.offsetWidth}px`;
	btnNext.style.top = `${nextTop}px`;
}

export function sliderSwiperWide() {
	if (document.querySelectorAll('.swiper__container.__wide').length) {
		document.querySelectorAll('.swiper__container.__wide').forEach((gallery) => {

			const gallerySlider = gallery.querySelector('.gallery-slider');
			const btnPrev = gallery.querySelector('.swiper-button-prev');
			const btnNext = gallery.querySelector('.swiper-button-next');
			const slidesLength = gallerySlider.querySelectorAll('.swiper-slide').length;
			let realIdx = 0;
			let lastIndex = 0;
			const updateNav = () => positionWideNav(gallery, gallerySlider, btnPrev, btnNext);
			let swiper = new Swiper(gallerySlider, {
				loop: true,
				slidesPerView: 1.2,
				centeredSlides: false,
				spaceBetween: 0,
				breakpoints: {
					[WIDE_MOBILE_BREAKPOINT + 1]: {
						slidesPerView: 5.65, // pudełko slajdu ~340px przy 1920px szerokości viewportu (boczne zdjęcia wypełniają je w 100%)
						centeredSlides: true,
						spaceBetween: 0,
					},
				},
				navigation: {
					nextEl: btnNext,
					prevEl: btnPrev,
				  },

				on: {
					init: updateNav,
					resize: updateNav,
					realIndexChange() {
						const eventAction =
						'ontouchstart' in document.documentElement ? 'tap' : 'click';
						const evType = this.swipeDirection ? 'swipe' : eventAction;
						const item = this.el.querySelector(
						`[data-swiper-slide-index="${this.realIndex}"]`
						);
						statsOnWidgetInteraction(
						item,
						item.querySelector('img').getAttribute('src'),
						this.realIndex,
						evType
						);
						realIdx = this.realIndex;
						updateNav();
					},
				},
			});

			window.addEventListener('resize', updateNav);
		});
	}
}